function formSetIsChanged($form) {
	if (!$form.length) return;

	$form.addClass('form--changed');
	window.beforeunload_enable = true;
}

function destroyJSTitleInFormReplicator() {
	$('.form-replicator .js-title, .form-replicator-add-static').tooltip('dispose');
}
function initJSTitleInFormReplicator() {
	$('.form-replicator .js-title, .form-replicator-add-static').tooltip();
}

$(function() {

	$.nette.ext('live').after(function($el){
		var $formReplicator = $el.find('.form-replicator');
		$formReplicator.formReplicator({
			deleteSelection: '.form-replicator-delete',
			addSelection: '.form-replicator-add',
			addStaticButton: function($el){
				return $el.next().find('.form-replicator-add-static');
			},
			beforeClone: function(e, $oldRow) {
				destroyJSTitleInFormReplicator();
				// const $select = $oldRow.find('select');
				// if ($select.hasClass('select2-hidden-accessible')) {
				// 	$select.select2("destroy");
				// }
			},
			beforeDelete: destroyJSTitleInFormReplicator,
			afterClone: function(e, $newRow, $oldRow, newRowCounter) {
				initJSTitleInFormReplicator();
				// initSelect2($formReplicator);
				formSetIsChanged($formReplicator.closest('form'));
				// datepickerInitInElement($newRow);
			},
			afterDelete: function() {
				initJSTitleInFormReplicator();
				formSetIsChanged($formReplicator.closest('form'));
			},
			// minRequired: 1 // TODO tohle hceme zprovoznit
		});

		$el.find('.js-title').tooltip();
		$el.find('.js-title').tooltip('hide');

		setTimeout(function () {
			// ublaboo datagrid zpracovává řádky vytažené ajaxem
			// a celý snippet vytáhne z DOMu dřív, takže $el je prázdný
			// počkáme si tedy, než je vrátí zpátky, znovu si provedeme ten samý dotaz
			// a inicializujeme tooltipy
			$($el.selector).find('.js-title').tooltip();
		}, 100);
	});


});
